import React from "react";
import Header from "../screens/home/components/header";
import { Outlet } from "react-router-dom";

const Layout = ()=>{
    return(
        <>
        <Header/>
        <Outlet/>
        </>
    )
}

export default Layout